<!--
    Styles
-->

<style>
    .l-popup {
        overflow: auto;
        display: flex;
        flex-flow: column nowrap;
        background: rgba(102,102,102,0.31);
        box-shadow: 0 0 16px 3px rgba(0, 0, 0, 0.5);
        padding: 20px;
    }
    .l-popup > * {
        margin: auto;
        border-radius: 6px;
    }
</style>



<!--
    Template
-->

<template>
    <popup-view class="l-popup u-expand" @click.native="close" />
</template>



<!--
    Scripts
-->

<script>
    export default {
        methods: {
            close (event) {
                if (event.target === this.$el) this.$popup.clear();
            }
        }
    }
</script>
